import { EnvelopeIcon } from '@heroicons/react/24/outline'

function NoTeam() {
    return (
        <section className="mx-auto max-w-xl rounded-lg border border-ink-200 bg-white p-10 text-center shadow-sm">
            <h2 className="font-sans text-xl font-medium leading-tight text-ink-900">
                You're not part of a team yet
                <span aria-hidden="true" className="text-arwen-600">
                    .
                </span>
            </h2>
            <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-ink-500">
                With a team, you and your colleagues can access and manage the same social profiles
                together.
            </p>
            <a
                href="mailto:support@arwen.ai?subject=Setting up a team"
                className="mt-6 inline-flex items-center gap-2 rounded-md bg-arwen-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-arwen-700 focus:outline-none focus:ring-2 focus:ring-arwen-500 focus:ring-offset-2"
            >
                <EnvelopeIcon className="h-4 w-4" aria-hidden="true" />
                Contact support to set one up
            </a>
        </section>
    )
}

export default NoTeam
